export default __webpack_public_path__ + "static/media/performers.58c89a19.jpg";